import Swal from "sweetalert2";
import i18n from "@/i18n";
import auth from "@/store/modules/auth";

const redirectToLoginModal = () => {
    Swal.fire({
        title: i18n.t('auth.login.loginRequired'),
        text: i18n.t('auth.login.loginRequiredText'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('auth.login.loginButton'),
        cancelButtonText: i18n.t('auth.login.cancelButton'),
    }).then((result) => {
        if (result.value) {
            auth.actions.redirectToLoginUrl();
        }
    });
}

export { redirectToLoginModal }
